import { useUserAccount } from '@pkgs/components/hooks/useUserAccount';
import { useAuth } from '@ev-tech/user-account-modules';

import { SearchAlertModal, type SearchAlertModalProps } from './UserAccount/SearchAlertModal';

const CreateSearchAlertModal = ({ ...props }: SearchAlertModalProps) => {
  const { state: userAccountState } = useUserAccount();
  const { isLoaded, isSignedIn } = useAuth();

  if (userAccountState.isOpen || !isLoaded || !isSignedIn) {
    return null;
  }

  return <SearchAlertModal {...props} />;
};

export default CreateSearchAlertModal;
